// Validasi UI untuk Payment Allocation Simulator.
// Hanya untuk gating tampilan (enable/disable tombol Simulate & pesan error).
// Perhitungan angka tetap dilakukan backend (source of truth).

import { RECIPIENT_TYPES } from "../constants/recipientTypes";

export const formatRupiah = (n) =>
  "Rp" + (Number(n) || 0).toLocaleString("id-ID");

// CEA selalu ada, readonly, dan persentasenya = discount.
export const hasCEA = (recipients) =>
  recipients.some((r) => r.type === RECIPIENT_TYPES.CEA);

// Kategori tidak boleh duplikat.
export const hasDuplicateCategory = (recipients) => {
  const types = recipients.map((r) => r.type);
  return new Set(types).size !== types.length;
};

// Total seluruh persentase harus tepat 100.
export const totalPercent = (recipients) =>
  recipients.reduce((sum, r) => sum + (Number(r.percent) || 0), 0);

// Recipient "Other Email" wajib punya email valid.
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");

export const validateRecipients = (recipients) => {
  const errors = [];

  if (!hasCEA(recipients)) {
    errors.push("CEA recipient is required.");
  }
  if (hasDuplicateCategory(recipients)) {
    errors.push("Duplicate recipient categories are not allowed.");
  }
  for (const r of recipients) {
    if (r.type === RECIPIENT_TYPES.OTHER_EMAIL && !isValidEmail(r.email)) {
      errors.push("Please enter a valid email for the Other Email recipient.");
      break;
    }
  }

  const total = totalPercent(recipients);
  if (total !== 100) {
    errors.push("Total percentage must equal 100%.");
  }

  return { valid: errors.length === 0, errors, total };
};
